// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_6hI","content":"styles_content__2M9UC"};